import React, { useEffect, useState } from 'react';
import { Navbar, Nav } from 'react-bootstrap';

const sections = ['about', 'demo', 'services', 'projects', 'approach', 'proof', 'contact', 'legalnotice'];



const Navigation = () => {
  const [active, setActive] = useState('');
  const [expanded, setExpanded] = useState(false);

  const iconMap = {
    about: 'fa-user',
    portfolio: 'fa-briefcase',
    contact: 'fa-envelope',
    legalnotice: 'fa-file-alt',
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
              .filter(entry => entry.isIntersecting)
              .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

          let current = '';
          if (visible.length > 0) {
            current = visible[0].target.getAttribute('id');
          } else if (window.scrollY < 200) {
            current = 'about';
          }

          if (current !== active) setActive(current);
        },
        {
          root: null,
          threshold: [0.1, 0.25, 0.5, 0.75, 1.0],
        }
    );

    sections.forEach(id => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [active]);

  const scrollTo = (e, id) => {
    e.preventDefault();
    setExpanded(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
      <div className="w-100">
        <Navbar
            expand="lg"
            variant="dark"
            fixed="top"  collapseOnSelect
            expanded={expanded}
            onToggle={setExpanded}
            className="navbar-custom nav-stable"
        >
          <div className="container nav-stable-inner">
            {/* Brand centered on mobile */}
            <Navbar.Brand className="brand-center nav-stable-brand" style={{ height: '100px', overflow: 'hidden' }}>
              <img src="/img/logo8.PNG" alt="logo" className="logo-img" style={{ height: '100%', maxHeight: '130px', objectFit: 'contain' }} />
            </Navbar.Brand>

            {/* Toggler pinned to right on mobile */}
            <Navbar.Toggle aria-controls="responsive-navbar-nav" className="toggler-right nav-stable-toggle" />

            <Navbar.Collapse id="responsive-navbar-nav" className="nav-stable-collapse">
              <Nav className="text-uppercase pt-2 pt-lg-0 nav-stable-nav">
                {sections.map((id) => (
                    <Nav.Link
                        key={id}
                        href={`#${id}`}
                        onClick={(e) => scrollTo(e, id)}
                        className={`nav-link ${active === id ? 'active' : ''}`} data-target={id}
                    >
                      <span className="mx-2">
                        {id === 'legalnotice'
                          ? 'Impressum'
                          : id === 'proof'
                            ? 'Trust'
                            : id === 'demo'
                              ? 'Demo'
                              : id}
                      </span>
                    </Nav.Link>
                ))}
              </Nav>
            </Navbar.Collapse>
          </div>
        </Navbar>
      </div>
  );
};

export default Navigation;

/*<!--  <i className={`fas ${iconMap[id]}`}></i> -->*/

